// components
import { SideEditorPanel } from '@components/SideEditor/SideEditor';
import type { FC } from 'react';

// consts and types
import { MenuItemsIndexDictionary } from '../../consts';
import { EmailSignatureSideEditorItems } from '../../types';
import EmailSignatureEditorPanelSection, {
  EmailSignatureEditorPanelSectionContents,
  EmailSignatureEditorPanelSectionHeading,
} from '../EmailSignatureEditorPanelSection';
import EmailSignatureEditorAddonsBannerBox from './EmailSignatureEditorAddonsBannerBox';
import EmailSignatureEditorAddonsEnvironmentalBox from './EmailSignatureEditorAddonsEnvironmentalBox';
import EmailSignatureEditorAddonsLegalDisclaimerBox from './EmailSignatureEditorAddonsLegalDisclaimerBox';

const EmailSignatureEditorAddonsPanel: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <SideEditorPanel index={MenuItemsIndexDictionary[EmailSignatureSideEditorItems.BANNERS]}>
      <EmailSignatureEditorPanelSection>
        <EmailSignatureEditorPanelSectionHeading heading={'Footers and Banner'} />
        <EmailSignatureEditorPanelSectionContents>
          <EmailSignatureEditorAddonsBannerBox />
          <EmailSignatureEditorAddonsEnvironmentalBox />
          <EmailSignatureEditorAddonsLegalDisclaimerBox />
        </EmailSignatureEditorPanelSectionContents>
      </EmailSignatureEditorPanelSection>
    </SideEditorPanel>
  );
};

export default EmailSignatureEditorAddonsPanel;
